module.exports = __webpack_public_path__ + "static/media/mob-app2.e26b89f8.jpg";